var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-render',{ref:"tableRender",attrs:{"propData":{ query: { payPassagewayCode: _vm.payPassagewayCode } },"config":_vm.config}})}
var staticRenderFns = []

export { render, staticRenderFns }